// @ts-nocheck

export default {
  GRANTS_TABLE_STATE_SET: 'GRANTS_TABLE_STATE_SET',
  GRANTS_TABLE_STATE_RESET: 'GRANTS_TABLE_STATE_RESET',
  SET_SELECTED_GRANT: 'SET_SELECTED_GRANT',
}; 